import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import MainLayoutSidebar from '../../../modules/MainLayout/MainLayoutSidebar';
import { DEFAULT_INSPECTION_LIST_SCOPE, DEFAULT_INSPECTION_LIST_STATUS, InspectionListingProvider, } from './InspectionListingProvider';
import InspectionListingPageWrapper from './InspectionListingPageWrapper';
import SuspenseWrapper from '../../../modules/SuspenseWrapper/SuspenseWrapper';
import useCanUserViewFeature from '../../../../hooks/useCanUserViewFeature';
import { getGetAllInspectionsQueryKey } from '../../../../services/api/generated/client';
import { queryClient } from '../../../../services/api/query/queryClient';
import { IN_PROGRESS, INSPECTION_STATUSES, PENDING, } from '../../../../constants/statuses';
import { useFeatureFlags } from '../../../../context/FeatureFlagProvider';
const InspectionListingPage = () => {
    const { scope = DEFAULT_INSPECTION_LIST_SCOPE, status = DEFAULT_INSPECTION_LIST_STATUS, } = useParams();
    const history = useHistory();
    const { usePendingStatus } = useFeatureFlags();
    const { canView: canViewTeam } = useCanUserViewFeature([
        'inspections.get-for-provider',
    ]);
    const inspectionStatus = +status;
    if (!INSPECTION_STATUSES.includes(inspectionStatus) ||
        (!usePendingStatus && inspectionStatus === PENDING)) {
        history.push(`/inspections/${scope}/${IN_PROGRESS}`);
    }
    return (React.createElement(InspectionListingProvider, { value: {
            canViewTeamInspections: canViewTeam,
            scope,
            status: inspectionStatus,
            onInspectionsMutated: (scopeToInvalidate) => {
                queryClient.invalidateQueries({
                    queryKey: getGetAllInspectionsQueryKey({
                        scope: scopeToInvalidate,
                    }),
                });
            },
        } },
        React.createElement(MainLayoutSidebar, { sidebarSection: "inspections", selected: "inspections" },
            React.createElement(SuspenseWrapper, null,
                React.createElement(InspectionListingPageWrapper, null)))));
};
export default InspectionListingPage;
